/**
 * AtlasEuropePage — Sprint 4B · Page 1 (overview)
 * Tile-less SVG choropleth of Europe on cream. Each country is filled along one
 * navy hue by its visited fraction (the fill IS the progress — no bar, no %).
 * Tap a visited country to drill into it. Read-only; never writes app state.
 */
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { buildEuropeView, fractionFill } from '../../utils/atlasMap';
import theme from '../../styles/theme';

export default function AtlasEuropePage({ onSelectCountry }) {
  const { t } = useTranslation('common');
  const [view, setView] = useState(null);

  useEffect(() => {
    let cancelled = false;
    buildEuropeView().then(v => { if (!cancelled) setView(v); }).catch(() => {});
    return () => { cancelled = true; };
  }, []);

  if (!view) return <div style={S.loading}>…</div>;

  return (
    <div style={S.wrap}>
      <svg viewBox={view.viewBox} style={S.svg} preserveAspectRatio="xMidYMid meet">
        {view.features.map((f, i) => {
          const fill = fractionFill(f.fraction);
          const clickable = f.visited && f.appCountry;
          return (
            <path
              key={i}
              d={f.d}
              fill={fill || 'transparent'}
              stroke={f.appCountry ? theme.brown : theme.sand}
              strokeWidth={f.appCountry ? 0.8 : 0.5}
              strokeOpacity={f.appCountry ? 0.7 : 0.35}
              style={{ cursor: clickable ? 'pointer' : 'default' }}
              onClick={clickable ? () => onSelectCountry(f.appCountry) : undefined}
            >
              <title>{f.name}</title>
            </path>
          );
        })}
      </svg>
      <p style={S.caption}>{t('atlasBook.overviewHint')}</p>
    </div>
  );
}

const S = {
  wrap: { width: '100%' },
  loading: { textAlign: 'center', color: theme.sand, padding: '60px 0', fontSize: 14 },
  svg: {
    width: '100%', height: 'auto', maxHeight: '58vh', display: 'block',
    background: theme.cream, borderRadius: 14,
    border: `1px solid ${theme.creamDeep}`,
  },
  caption: {
    textAlign: 'center', margin: '12px 4px 0', fontSize: 13, lineHeight: 1.5,
    color: theme.brown, fontStyle: 'italic',
  },
};
